import type { InputHTMLAttributes } from 'react';

export enum LiliRadioInputSize {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
}

export enum LiliRadioInputVariant {
  DOT = 'dot',
  CHECKMARK = 'checkmark',
}

interface LiliRadioInputBaseProps extends Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'size'
> {
  checked?: boolean;
  disabled?: boolean;
  size?: LiliRadioInputSize;
  variant?: LiliRadioInputVariant;
}

export type LiliRadioInputProps = LiliRadioInputBaseProps &
  (
    | {
        label: string;
        id: string;
      }
    | {
        label?: never;
        id?: string;
      }
  );
